import { List as AntdList } from "@empglabs/backoffice-ui-kit"

const List = props => {
  return <AntdList {...props} />
}

export default List
